import { Head } from '@inertiajs/react'
import AppLayout from '@/components/AppLayout'
import { OverviewPage } from '@/components/screens/OverviewScreen'

/* The Inertia boundary. The screen below still reads from @/fixtures; when a
 * controller starts handing this page real props they get passed through here,
 * and the screen stops importing fixtures at all. */
export default function Overview() {
  return (
    <AppLayout>
      <Head title="Overview" />
      <OverviewPage />
    </AppLayout>
  )
}
